<template>
  <div class="min-h-screen flex items-center justify-center bg-slate-50 px-4">
    <div class="max-w-md w-full bg-white rounded-2xl shadow-xl p-10 text-center">
      <div class="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
        <svg
            class="h-8 w-8 text-red-600"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            viewBox="0 0 24 24"
        >
          <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 9v3m0 4h.01M4.93 19h14.14c1.54 0 2.5-1.67 1.73-3L13.73 4c-.77-1.33-2.69-1.33-3.46 0L3.2 16c-.77 1.33.19 3 1.73 3z"
          />
        </svg>
      </div>

      <h1 class="text-3xl font-bold text-slate-800 mb-3">
        Přístup zamítnut
      </h1>

      <p class="text-slate-600 text-lg mb-8 leading-relaxed">
        Nemáte oprávnění k přístupu do této části aplikace.
        <br />
        Pokud si myslíte, že je to chyba, kontaktujte administrátora.
      </p>

      <div class="flex flex-col gap-3">
        <button
            @click="appStore.logout()"
            class="w-full rounded-lg bg-slate-900 px-5 py-3 text-white font-medium hover:bg-slate-800 transition"
        >
          Odhlásit se
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {useAppStore} from "@/stores/appStore";

export default {
  name: "UnauthorizedView",
  data(){
    return {
      appStore: useAppStore()
    }
  }
}
</script>
